import { useMemo } from 'react';

import type { marked } from 'marked';
import { Slugger } from 'marked';

import type { IHeadings } from '../components/content-markdown/content-markdown';

const markedSlugger = new Slugger();

export function useHeading(content: marked.TokensList) {
    const headings: Array<IHeadings> = useMemo(() => {
        return content
            .filter((token): token is marked.Tokens.Heading => {
                return token.type === 'heading' && token.depth === 1;
            })
            .map((heading) => {
                return {
                    level: heading.depth,
                    title: heading.text,
                    id: markedSlugger.slug(heading.text, { dryrun: true }),
                };
            });
    }, [content]);

    return headings;
}
